export const resetWithTimeout = (fn, defaultValue = null, timeout = 5000) =>
	setTimeout(() => {
		fn(() => defaultValue);
	}, timeout);
